import { createContext, useContext, useState } from 'react';
import { useRouter } from 'next/router';
export const QualityContext = createContext({
  activePanel: 'insights',
  setActivePanel: () => null
});
export const QualityProvider = ({
  children
}) => {
  const router = useRouter();
  const {
    slug
  } = router.query;
  const navigate = panel => {
    router.push(`/admin/quality/${panel}`);
    setActivePanel(panel);
  };
  const [activePanel, setActivePanel] = useState(Array.isArray(slug) ? slug[0] : 'matching');
  return <QualityContext.Provider value={{
    activePanel,
    setActivePanel: navigate
  }}>
      {children}
    </QualityContext.Provider>;
};
export const useQuality = () => useContext(QualityContext);